import { act } from "react";
import { AppState, Categorie_pieces, FolderType, Garant, GarantMonoBloc, GarantPhysique, Sections_dossier, Type_dossier, Type_garantie } from "shared/types/types";
import { makeEmptyLocataire, uuid } from "./IDLocker_utils";

export type Action = 
    | {type: "OPEN_CREATE"; open: boolean}
    | {type: "CREATE_DOSSIER"; payload : { type: Type_dossier; name?: string}}
    | {type: "OPEN_DOSSIER"; id: number; left?: Sections_dossier}
    | {type: "GO_GRID"}
    | {type: "TOGGLE_SECRET"; id: number}
    | {type: "ADD_LOCATAIRE_DOC"; id: number; category: Categorie_pieces; files: {id: string; name:string;}[] }
    | {type: "REMOVE_LOCATAIRE_DOC"; id: number; category: Categorie_pieces;docId: string}
    | {type: "ADD_GARANT"; id: number; garant_type: Type_garantie}
    | {type: "OPEN_GARANT_DETAIL"; id: number; garant_id: string}
    | {type: "GO_BACK_TO_GARANTS"; id: number}
    | {type: "TOGGLE_GARANT"; id: number; garant_id: string}
    | {type: "ADD_GARANT_DOC"; id: number; garant_id: string; category: Categorie_pieces;  files: {id:string; name:string}[]}
    | {type: "ADD_GARANT_CERTIFICATE"; id: number; garant_id: string; files: {id:string; name:string}[] }
    | { type: "REMOVE_GARANT_DOC"; id: number; garantId: string; category: Categorie_pieces; docId: string | number }
    | { type: "REMOVE_GARANT_CERTIFICATE"; id: number; garantId: string; docId: string | number };

export const reducer = (state: AppState, action: Action): AppState => {
    switch(action.type){
        case "OPEN_CREATE": return { 
            ...state, 
            ui:{ ...state.ui, showCreate: action.open}
        };

        case "CREATE_DOSSIER": {
            const id = Math.floor(Math.random() * 1000000);
            const name = action.payload.type === Type_dossier.AUTRE ? (action.payload.name?.trim() || "Nouveau dossier") 
                : action.payload.type === Type_dossier.LOCATION_LOGEMENT ? "Location de logement" : "Véhicule d\'occasion"; 
            const dossier = { 
                id,
                name,
                visibility: true,
                system: false,
                adminAccess: false,
                ownerId: 1, // par défaut
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
                documents: [],
                authorizations: [],
                items: [],
                type: action.payload.type,
                locataire: makeEmptyLocataire(),
                garants: [] as Garant[]
            };
            return {
                dossiers: [dossier, ...state.dossiers], 
                ui: { route: {dossierId:id,
                    left: Sections_dossier.LOCATAIRE},
                showCreate: false
                }
            };
        };

        case "OPEN_DOSSIER": return { 
            ...state, 
            ui: {
                ...state.ui,
                route: { dossierId: action.id, left: action.left?? Sections_dossier.LOCATAIRE},
                showCreate: false
            }
        };

        case "GO_GRID": return {
            ...state,
            ui: {
                ...state.ui,
                route: "grid"
            }
        };

        case "TOGGLE_SECRET": {
            const dossiers = state.dossiers.map(d => d.id === action.id ? { ...d, visibility: !d.visibility} : d);
            return {
                ...state,
                dossiers
            };
        };

        case "ADD_LOCATAIRE_DOC": {
            const { id, category, files } = action;
            return {
                ...state,
                dossiers: state.dossiers.map(d =>
                d.id !== id
                    ? d
                    : {
                        ...d,
                        documents: [
                        ...(d.documents ?? []),
                        ...files.map((f, idx) => ({
                            id: Date.now() + idx,
                            name: f.name,
                            category,
                            url: "",
                            type: "",
                            size: 0,
                            uploadedAt: new Date().toISOString(),
                        })),
                        ],
                    }
                ),
            };
        }

            case "REMOVE_LOCATAIRE_DOC": {
            const { id, docId } = action;
            return {
                ...state,
                dossiers: state.dossiers.map(d =>
                d.id !== id
                    ? d
                    : {
                        ...d,
                        documents: (d.documents ?? []).filter((doc: any) => doc.id !== docId),
                    }
                ),
            };
        }


        case "ADD_GARANT": {
            const dossiers = state.dossiers.map(d =>{
                if(d.id !== action.id) return d;

                console.log('lmlm')
                
                const garant_id = uuid();
                let newGarant: Garant;
                
                if (action.garant_type === Type_garantie.PHYSIQUE) {
                    newGarant = {
                        id: garant_id,
                        name: `Garant Physique ${(d.garants?.length || 0) + 1}`,
                        type: Type_garantie.PHYSIQUE,
                        depliee: false,
                        docs: makeEmptyLocataire()
                    } as GarantPhysique;
                } else {
                    newGarant = {
                        id: garant_id,
                        name: action.garant_type === Type_garantie.INSTITUTIONNEL 
                            ? `Garant Institutionnel ${(d.garants?.length || 0) + 1}`
                            : `Garant Bancaire ${(d.garants?.length || 0) + 1}`,
                        type: action.garant_type,
                        depliee: false,
                        certificate: []
                    } as GarantMonoBloc;
                }
                
                return {
                    ...d,
                    garants: [...(d.garants || []), newGarant]
                };
            });
            
            const newgarant_id = dossiers.find(d => d.id === action.id)?.garants?.slice(-1)[0]?.id;
            
            return {
                ...state,
                dossiers,
                ui: {
                    ...state.ui,
                    route: {
                        dossierId: action.id,
                        left: Sections_dossier.GARANTS,
                        garantDetail: newgarant_id
                    }
                }
            };
        };

        case "OPEN_GARANT_DETAIL": {
            return {
                ...state,
                ui: {
                    ...state.ui,
                    route: {
                        dossierId: action.id,
                        left: Sections_dossier.GARANTS,
                        garantDetail: action.garant_id
                    }
                }
            };
        };

        case "GO_BACK_TO_GARANTS": {
            return {
                ...state,
                ui: {
                    ...state.ui,
                    route: {
                        dossierId: action.id,
                        left: Sections_dossier.GARANTS
                    }
                }
            };
        };

        case "TOGGLE_GARANT": {
            const dossiers = state.dossiers.map(d =>{
                if(d.id !== action.id) return d;
                return {
                    ...d,
                    garants: d.garants?.map(g => 
                        g.id === action.garant_id 
                            ? { ...g, depliee: !g.depliee }
                            : g
                    ) || []
                };
            });
            return {
                ...state,
                dossiers
            };
        };

        case "ADD_GARANT_DOC": {
            const { id, garant_id, category, files } = action;
            return {
                ...state,
                dossiers: state.dossiers.map(d =>
                d.id !== id ? d : {
                    ...d,
                    garants: (d.garants ?? []).map(g =>
                    g.id !== garant_id || g.type !== Type_garantie.PHYSIQUE ? g : {
                        ...g,
                        docs: {
                        ...g.docs,
                        [category]: [...(g.docs?.[category] ?? []), ...files],
                        },
                    })
                })
            };
        }

        case "REMOVE_GARANT_DOC": {
            const { id, garantId, category, docId } = action;
            return {
                ...state,
                dossiers: state.dossiers.map(d =>
                d.id !== id ? d : {
                    ...d,
                    garants: (d.garants ?? []).map(g => {
                    if (g.id !== garantId || g.type !== Type_garantie.PHYSIQUE) return g;
                    const docs = g.docs ?? {};
                    const arr = Array.isArray(docs[category]) ? docs[category] : [];
                    return {
                        ...g,
                        docs: {
                        ...docs,
                        [category]: arr.filter((it: any) => String(it.id) !== String(docId)),
                        },
                    };
                    })
                })
            };
        }


        case "REMOVE_GARANT_CERTIFICATE": {
            const { id, garantId, docId } = action;
            return {
                ...state,
                dossiers: state.dossiers.map(d =>
                    d.id !== id ? d : {
                    ...d,
                    garants: (d.garants ?? []).map(g => {
                        if (g.id !== garantId || g.type === Type_garantie.PHYSIQUE) return g;
                        const certs = Array.isArray((g as any).certificate) ? (g as any).certificate : [];
                        return {
                        ...g,
                        certificate: certs.filter((it: any) => String(it.id) !== String(docId)),
                        };
                    })
                })
            };
        }

        case "ADD_GARANT_CERTIFICATE": {
            const { id, garant_id, files } = action;
            return {
                ...state,
                dossiers: state.dossiers.map(d =>
                d.id !== id ? d : {
                    ...d,
                    garants: (d.garants ?? []).map(g =>
                    g.id !== garant_id || (g.type === Type_garantie.PHYSIQUE) ? g : {
                        ...g,
                        certificate: [...(g.certificate ?? []), ...files],
                    }
                    )
                })
            };
        }
        default: return state;
    }
};

